<mat-accordion class="row accordian" *ngIf="page !== 'story-v2'" [ngClass]="config?.type">
  <div class="col-md-6 full-width">
    <mat-expansion-panel #panel1 *ngFor="let item of faqs1;" class="panel">
      <mat-expansion-panel-header class="pannel-header" [collapsedHeight]="expHeight" [expandedHeight]="expHeight">
        <mat-panel-title class="title">
          <mat-icon>{{panel1.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon> {{item.title}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="desc">
        <div [innerHTML]="item?.desc | safeHtml"></div>
        <app-button class="desc-btn" *ngIf="item?.contact && !vars.thirdPartyApp" type="button" btnClass="primary-btn" label="Contact" (click)="openDialog()"></app-button>
      </div>
    </mat-expansion-panel>
  </div>
  <div class="col-md-6 full-width">
    <mat-expansion-panel #panel1 *ngFor="let item of faqs2;" class="panel">
      <mat-expansion-panel-header class="pannel-header" [collapsedHeight]="expHeight" [expandedHeight]="expHeight">
        <mat-panel-title class="title">
          <mat-icon>{{panel1.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon> {{item.title}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="desc" [innerHTML]="item?.desc"></div>
    </mat-expansion-panel>
  </div>
</mat-accordion>


<mat-accordion class="row story-v2" *ngIf="page === 'story-v2'" [ngClass]="cls">
  <div class="col-md-12 full-width">
    <mat-expansion-panel #panel1 *ngFor="let item of faqs1;" class="panel">
      <mat-expansion-panel-header class="pannel-header" [collapsedHeight]="expHeight" [expandedHeight]="expHeight">
        <mat-panel-title class="title">
          {{item.title}}
          <mat-icon *ngIf="type=='v1'">{{panel1.expanded ? 'remove_circle_outline' : 'add_circle_outline' }}</mat-icon>
          <mat-icon *ngIf="type=='v3'">{{panel1.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="desc">
        <div [innerHTML]="item?.desc | safeHtml"></div>
        <app-button class="desc-btn" *ngIf="item?.contact && !vars.thirdPartyApp" type="button" btnClass="primary-btn" label="Contact" (click)="openDialog()"></app-button>
      </div>
    </mat-expansion-panel>
  </div>
  <div class="col-md-12 full-width">
    <mat-expansion-panel #panel1 *ngFor="let item of faqs2;" class="panel">
      <mat-expansion-panel-header class="pannel-header" [collapsedHeight]="expHeight" [expandedHeight]="expHeight">
        <mat-panel-title class="title">
          {{item.title}}
          <mat-icon *ngIf="type=='v1'">{{panel1.expanded ? 'remove_circle_outline' : 'add_circle_outline' }}</mat-icon>
          <mat-icon *ngIf="type=='v3'">{{panel1.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="desc" [innerHTML]="item?.desc"></div>
    </mat-expansion-panel>
  </div>
</mat-accordion>